<template>
    <div id="alt-minicart" :class="isToggle ? 'active' : ''" @click="toggleMiniCart($event, emit)">
        <div class="alt-minicart-wrapper widget_shopping_cart_content"></div>
    </div>
</template>

<script lang="ts" setup>
import { toggleMiniCart, getMiniCart, getTotalCart } from '@/assist/MiniCart'

interface Props {
  'isToggle': boolean
}

withDefaults(defineProps<Props>(), {});

const emit = defineEmits<{
    (e: 'toggle-minicart'): void
}>();
const firstLoad = ref(false);

const removeInteractionListeners = () => {
    window.removeEventListener('mousemove', loadMiniCartOnInteraction);
    window.removeEventListener('touchstart', loadMiniCartOnInteraction);
};

const loadMiniCartOnInteraction = () => {
    if (firstLoad.value) return;
    firstLoad.value = true;
    removeInteractionListeners();
    void getMiniCart();
};

onMounted(() => {
    void getTotalCart();
    window.addEventListener('mousemove', loadMiniCartOnInteraction, { once: true, passive: true });
    window.addEventListener('touchstart', loadMiniCartOnInteraction, { once: true, passive: true });
});

onBeforeUnmount(removeInteractionListeners);
</script>
